import React, { useState, useEffect } from 'react';
import MapComponent from '../components/MapComponent';
import Menu from '../components/Menu';
import { db, storage } from '../firebase'; 
import { collection, addDoc, serverTimestamp, doc, getDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const HomePage = ({ user, handleLogout }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [mediaFile, setMediaFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const [userData, setUserData] = useState({ adSoyad: '', telefon: '' });

  useEffect(() => {
    const fetchUserData = async () => {
      if (user?.uid) {
        try {
          let userDoc = await getDoc(doc(db, "users", user.uid));
          if (!userDoc.exists()) userDoc = await getDoc(doc(db, "kullanicilar", user.uid));
          
          if (userDoc.exists()) {
            const data = userDoc.data();
            setUserData({
              adSoyad: data.adSoyad || data.firstName + ' ' + data.lastName || data.isimSoyisim || data.name || user.displayName || user.email,
              telefon: data.telefon || data.phone || data.tel || "Belirtilmemiş"
            });
          } else {
            setUserData({ adSoyad: user.displayName || user.email, telefon: "Belirtilmemiş" });
          }
        } catch (error) {
          console.error("Kullanıcı bilgileri çekilemedi:", error);
          setUserData({ adSoyad: user.displayName || user.email, telefon: "Belirtilmemiş" });
        }
      }
    };
    fetchUserData();
  }, [user]);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setMediaFile(e.target.files[0]);
    }
  };

  const handleReportSubmit = async (type) => {
    if (!user || !mediaFile) {
        MySwal.fire({ 
            title: 'Eksik Bilgi', 
            text: 'Lütfen olayı gösteren bir kanıt (fotoğraf/video) ekleyiniz.', 
            icon: 'warning',
            confirmButtonColor: '#334155',
            customClass: { container: 'z-[999999]' }
        });
        return;
    }

    setIsSubmitting(true);
    MySwal.fire({ 
        title: 'Gönderiliyor', 
        text: 'İhbarınız sisteme işleniyor, lütfen bekleyin...',
        allowOutsideClick: false, 
        customClass: { container: 'z-[999999]' },
        didOpen: () => MySwal.showLoading() 
    });

    if (!navigator.geolocation) {
        MySwal.fire({ title: 'Hata', text: 'Cihazınızın konum servisi kapalı veya desteklenmiyor.', icon: 'error', customClass: { container: 'z-[999999]' } });
        setIsSubmitting(false);
        return;
    }

    navigator.geolocation.getCurrentPosition(async (position) => {
      const { latitude, longitude } = position.coords;

      try {
        const fileExtension = mediaFile.name.split('.').pop();
        const mediaRef = ref(storage, `ihbarlar/${Date.now()}_ihbar.${fileExtension}`);
        const snapshot = await uploadBytes(mediaRef, mediaFile);
        const mediaUrl = await getDownloadURL(snapshot.ref);

        await addDoc(collection(db, "ihbarlar"), {
          konum: { enlem: latitude, boylam: longitude },
          tip: type,
          zaman: serverTimestamp(),
          kullaniciEmail: user.email,
          adSoyad: userData.adSoyad,
          telefon: userData.telefon,
          medyaUrl: mediaUrl,
          medyaTipi: mediaFile.type.startsWith('video/') ? 'video' : 'image',
          durum: "Bekliyor"
        });

        MySwal.fire({ 
            icon: 'success', 
            title: 'İhbar Alındı', 
            text: 'Bildiriminiz ekiplere iletildi. Duyarlılığınız için teşekkür ederiz.', 
            timer: 4000, 
            showConfirmButton: false,
            customClass: { container: 'z-[999999]' }
        });

      } catch (error) {
        MySwal.fire({ title: 'Bağlantı Hatası', text: error.message, icon: 'error', customClass: { container: 'z-[999999]' } });
      } finally {
        setIsSubmitting(false);
        setIsModalVisible(false);
        setMediaFile(null);
      }
    }, () => {
      setIsSubmitting(false);
      MySwal.fire({ title: 'Konum İzni Gerekli', text: 'İhbarın doğruluğu için konum erişimine izin vermelisiniz.', icon: 'error', customClass: { container: 'z-[999999]' } });
    }, { enableHighAccuracy: true });
  };

  return (
    <div className="relative h-screen w-full overflow-hidden font-sans antialiased bg-slate-100 text-slate-800">
      
      <button 
        className="fixed top-5 right-5 z-[9999] bg-white border border-slate-200 text-slate-700 w-12 h-12 rounded-2xl shadow-lg flex items-center justify-center hover:bg-slate-50 active:scale-95 transition-all" 
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M4 6h16M4 12h16M4 18h16" /></svg>
      </button>

      <Menu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} onLogout={handleLogout} userEmail={user.email} userName={userData.adSoyad} />
      
      <div className="absolute inset-0 z-0">
        <MapComponent />
      </div>

      <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-[5000] w-auto px-4">
        <button 
          className="relative flex items-center justify-center gap-3 bg-gradient-to-b from-red-500 to-red-600 text-white w-full py-4 px-8 rounded-full font-bold text-lg tracking-wide 
          shadow-[0_6px_0_#991b1b,0_15px_20px_rgba(220,38,38,0.3)] whitespace-nowrap
          active:shadow-[0_0px_0_#991b1b,0_0px_0_rgba(220,38,38,0.3)] active:translate-y-[6px] transition-all border border-red-400/50" 
          onClick={() => setIsModalVisible(true)}
        >
          <svg className="w-6 h-6 animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" /></svg>
          TEHLİKE BİLDİR
        </button>
      </div>

      {isModalVisible && (
        <div className="fixed inset-0 bg-slate-900/80 flex justify-center items-end sm:items-center z-[99999] p-0 sm:p-4 backdrop-blur-sm">
          <div className="bg-white w-full max-w-md rounded-t-[32px] sm:rounded-[32px] p-8 shadow-2xl animate-in slide-in-from-bottom duration-300">
            <div className="w-12 h-1.5 bg-slate-200 rounded-full mx-auto mb-6 sm:hidden"></div>
            
            <h2 className="text-2xl font-extrabold text-slate-800 mb-2">Kanıt Yükle</h2>
            <p className="text-slate-500 text-sm mb-6 font-medium">Lütfen olayı net gösteren bir fotoğraf veya video seçerek tipi belirleyin.</p>
            
            {/* YENİ: İKİLİ BUTON YAPISI (Kamera ve Galeri) */}
            <div className="flex gap-3 mb-8">
              <label className="flex flex-col items-center justify-center flex-1 p-4 border-2 border-dashed border-red-200 bg-red-50 text-red-600 rounded-2xl cursor-pointer hover:bg-red-100 transition-colors active:scale-95 shadow-sm">
                <span className="text-[10px] font-black uppercase tracking-widest text-center">
                  {mediaFile ? `✅ YÜKLENDİ` : '📸 KAMERADAN ÇEK'}
                </span>
                <input type="file" className="hidden" accept="image/*,video/*" capture="environment" onChange={handleFileChange} />
              </label>

              <label className="flex flex-col items-center justify-center flex-1 p-4 border-2 border-dashed border-slate-200 bg-slate-50 text-slate-600 rounded-2xl cursor-pointer hover:bg-slate-100 transition-colors active:scale-95 shadow-sm">
                <span className="text-[10px] font-black uppercase tracking-widest text-center">
                  {mediaFile ? `✅ SEÇİLDİ` : '🖼️ GALERİDEN SEÇ'}
                </span>
                <input type="file" className="hidden" accept="image/*,video/*" onChange={handleFileChange} />
              </label>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-6">
              <button 
                onClick={() => handleReportSubmit('Duman')} 
                disabled={isSubmitting} 
                className="flex flex-col items-center justify-center gap-2 bg-slate-700 text-white py-4 rounded-2xl font-bold shadow-[0_5px_0_#334155] active:shadow-[0_0px_0_#334155] active:translate-y-[5px] transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19h6" /></svg>
                DUMAN
              </button>
              
              <button 
                onClick={() => handleReportSubmit('Alev')} 
                disabled={isSubmitting} 
                className="flex flex-col items-center justify-center gap-2 bg-red-600 text-white py-4 rounded-2xl font-bold shadow-[0_5px_0_#991b1b] active:shadow-[0_0px_0_#991b1b] active:translate-y-[5px] transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24"><path d="M17.66 11.2C17.43 10.9 17.15 10.64 16.89 10.38C16.22 9.78 15.46 9.35 14.82 8.72C13.33 7.26 13 4.85 13.95 3C13 3.23 12.17 3.75 11.46 4.32C8.87 6.4 7.85 10.05 9.1 13.22C9.15 13.34 9.15 13.48 9.08 13.59C9.02 13.71 8.89 13.78 8.76 13.78C8.61 13.78 8.48 13.68 8.41 13.54C7.77 12.08 7.9 10.34 8.68 9.06C6.46 10.91 5.3 14.07 6.2 16.89C6.67 18.36 7.6 19.64 8.85 20.47C10.68 21.68 13 22.14 15.17 21.67C18.17 21 20.3 18.36 20.47 15.31C20.57 13.59 19.46 12.02 17.66 11.2ZM14.15 19.34C13.12 19.92 11.83 20 10.74 19.46C9.9 19.04 9.32 18.25 9.11 17.34C8.94 16.63 9.08 15.89 9.45 15.26C9.72 14.8 10.11 14.41 10.57 14.11C11.39 13.57 11.75 12.56 11.45 11.66C12.43 12.5 13.28 13.5 13.59 14.75C13.7 15.19 13.6 15.65 13.35 16C13.06 16.41 12.58 16.63 12.08 16.63C11.53 16.63 11 16.27 10.78 15.77C10.68 15.54 10.39 15.42 10.15 15.53C9.91 15.63 9.8 15.91 9.9 16.15C10.35 17.15 11.38 17.8 12.5 17.8C13.43 17.8 14.31 17.38 14.85 16.64C15.54 15.7 15.64 14.4 15.21 13.35C16.31 14.36 16.92 15.82 16.8 17.29C16.7 18.17 16.12 18.94 15.34 19.34H14.15Z"/></svg>
                ALEV
              </button>
            </div>
            
            <button 
              onClick={() => { setIsModalVisible(false); setMediaFile(null); }} 
              className="w-full text-slate-500 py-3 font-semibold text-sm hover:text-red-600 transition-colors"
            >
              Vazgeç / Kapat
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePage;